import AsyncPage from 'pages/AsyncPage'

import universal from 'react-universal-component'
const component = universal(props => import('./ForgotPasswordPage.js'))

export default new AsyncPage({
  isChromeless: true,
  pageComponent: component
})
